
export interface PersonalityInsight {
  id: string;
  user_id: string;
  big_five_result_id: string;
  analysis_content: any;
  summary: string;
  created_at: string;
  updated_at: string;
}

export const getPersonalityInsights = async (): Promise<PersonalityInsight[]> => {
  try {
    console.log('Getting personality insights - service temporarily disabled');
    // Temporarily return empty array to avoid build errors
    return [];
  } catch (error) {
    console.error('Erro ao buscar insights:', error);
    return [];
  }
};

export const getInsightById = async (insightId: string): Promise<PersonalityInsight | null> => {
  try {
    console.log('Getting insight by ID - service temporarily disabled:', insightId);
    // Temporarily return null to avoid build errors
    return null;
  } catch (error) {
    console.error('Erro ao buscar insight:', error);
    return null;
  }
};
